import { requests } from "../../utils/api/api.service";
import {
  ADMIN_USERS_URL,
  FORGOT_PASSWORD_URL,
  LOGIN_URL,
  RESET_PASSWORD_URL,
  WEB_USERS_URL,
} from "../../utils/api/endpoints";
import { ILogin } from "../../shared/interfaces/user/IUser";

const getRolesFromToken = (): string[] => {
  try {
    const token = localStorage.getItem("accessToken") || localStorage.getItem("token");
    if (!token) return [];
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.roles || payload.role || [];
  } catch {
    return [];
  }
};

export const AuthService = {
  login: async (
    payload: ILogin,
  ): Promise<{
    data: {
      accessToken: string;
    };
  }> => requests.post(LOGIN_URL, payload),
  me: async () => {
    const roles = getRolesFromToken();
    const isOperator = roles.some(
      (r: string) => (typeof r === "string" ? r : "").toUpperCase() === "OPERATOR"
    );
    if (isOperator) {
      return requests.get(`${WEB_USERS_URL}/me`);
    }
    return requests.get(`${ADMIN_USERS_URL}/me`);
  },
  forgotPassword: async (email: string): Promise<void> =>
    requests.post(FORGOT_PASSWORD_URL, { email }),
  resetPassword: async (
    token: string,
    newPassword: string,
    confirmPassword: string,
  ): Promise<void> =>
    requests.post(RESET_PASSWORD_URL, { token, newPassword, confirmPassword }),
};

